// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"_16fpmsrP5FU0Nhgdje_4SN","Open":"_1WnTKq7TrTbHiXpCwPkoUU","Close":"_2BHTNz6PJDUJANOeV-CXfL","Logo":"Y1lJkAtijyt_KrWb2nzqK"};